export default "__VITE_ASSET__DZMOcmsg__"